export const HIGHLIGHT_COLOR = Styles.color.loyaltyHighlight;

export const incentiveCardImageDefaultProps = {};

export const SHOULD_SELECT_STORE = false;
export const DISABLE_IN_RESTAURANT_FOR_INVALID_SERVICE_MODE = false;
